import { AccordionProps as MuiAccordionProps } from '@mui/material/Accordion'

export type AccordionProps = MuiAccordionProps
